var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNicaragua(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.001C24.8366 32.001 32 24.8375 32 16.001C32 7.16442 24.8366 0.000976562 16 0.000976562C7.16344 0.000976562 0 7.16442 0 16.001C0 24.8375 7.16344 32.001 16 32.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 0.000976562C9.6564 0.000976562 4.1754 3.69254 1.5874 9.04448H30.4121C27.8242 3.69254 22.3431 0.000976562 15.9998 0.000976562V0.000976562Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 32.001C22.3431 32.001 27.8242 28.3095 30.4122 22.9575H1.5874C4.1754 28.3095 9.6564 32.001 15.9998 32.001Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 11.1315C13.3108 11.1315 11.1306 13.3117 11.1306 16.0011C11.1306 18.6904 13.3108 20.8706 16.0002 20.8706C18.6896 20.8706 20.8697 18.6904 20.8697 16.0011C20.8697 13.3117 18.6896 11.1315 16.0002 11.1315ZM16.0002 18.7837C14.4634 18.7837 13.2176 17.5379 13.2176 16.0011C13.2176 14.4642 14.4634 13.2184 16.0002 13.2184C17.537 13.2184 18.7828 14.4642 18.7828 16.0011C18.7828 17.5379 17.5369 18.7837 16.0002 18.7837Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4101 16.6966L16.0002 16.001L13.5904 16.6966L12.7871 18.0879H19.2133L18.4101 16.6966Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 12.5228L14.3936 15.3055L16.0001 16.0011L17.6067 15.3055L16.0001 12.5228Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5898 16.6965H18.4096L17.6063 15.3052H14.3932L13.5898 16.6965Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNicaragua);
export default __webpack_public_path__ + "static/media/nicaragua.154d8d38.svg";
export { ForwardRef as ReactComponent };